import React, { FunctionComponent, useState, useRef } from 'react';
import Button, { BUTTON_TYPES } from '@buyside/components/presentation/Button/button';
import styles from './expandableStyles.scss';

export interface ExpandableProps {
  children?: React.ReactNode;
  maxItems: number;
}

const Expandable: FunctionComponent<ExpandableProps> = ({
  children,
  maxItems
}): React.ReactElement => {
  const [expanded, setExpanded] = useState(false);
  const wrapper = useRef<HTMLDivElement>(null);

  const toggleExpanded = (): void => {
    if (expanded && wrapper.current) {
      wrapper.current.scrollIntoView();
    }
    setExpanded(!expanded);
  };

  const displayChildren = expanded ? children : React.Children.toArray(children).slice(0, maxItems);
  return (
    <>
      <div ref={wrapper} />
      {displayChildren}
      {React.Children.count(children) > maxItems && (
        <div className={styles.expandButtonWrap}>
          <Button
            text={expanded ? 'Collapse' : 'Show All'}
            onClick={toggleExpanded}
            type={BUTTON_TYPES.LINK}
          />
        </div>
      )}
    </>
  );
};

export default Expandable;
